/**
 * ============================================================
 * KEJJA OS — src/hooks/useOffboarding.ts
 * ============================================================
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { offboardingApi } from '@/lib/offboardingApi';

export function useLeaveHome() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (homeId: string) => offboardingApi.leaveHome(homeId),
    onSuccess: async () => { await qc.invalidateQueries(); },
  });
}

export function useTransferOwnership() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ homeId, toUserId }: { homeId: string; toUserId: string }) =>
      offboardingApi.transferOwnership(homeId, toUserId),
    onSuccess: async () => { await qc.invalidateQueries(); },
  });
}

export function useDeleteHome() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (homeId: string) => offboardingApi.deleteHome(homeId),
    onSuccess: async () => { await qc.invalidateQueries(); },
  });
}

export function useDeleteAccount() {
  return useMutation({
    mutationFn: () => offboardingApi.deleteAccount(),
    // On success, caller should redirect to /goodbye or /login and clear auth
  });
}
